export const ResponsiveBreakpoints = {
  Mini: "(min-width:321px)",
  Mobile: "(min-width:640px)",
  Tablet: "(min-width:768px)",
  Desktop: "(min-width:1024px)",
};
